import { MediaTemplate } from "types/";

// Drops any slide entry from the template whose `name` (= slide uuid) no
// longer corresponds to an actual slide in the storyboard. Stale entries
// can linger from earlier sessions and break downstream rendering, so we
// scrub them on every save.
export const removeOrphanedSlides = (
  template: MediaTemplate,
  validSlideUuids: Set<string>
): MediaTemplate => {
  if (!template.slides) return template;
  return {
    ...template,
    slides: template.slides.filter((s) => validSlideUuids.has(s.name)),
  };
};
